import produce from "immer"
let initialState = {
    data: false
}

export const RebrandReducer = (state = initialState, action) => {
    switch (action.type) {

        case 'ADD_REBRAND':
            return produce(state, (draft) => {
                draft.data = action.payload
            })

        case 'REMOVE_ADD_REBRAND':
            return produce(state, (draft) => {
                draft.data = false
            })

        default:
            return state

    }
}